export namespace UserAction {

  export class FetchProfile {

    static readonly type = '[UserAction] Fetch Profile';
    constructor(public id: number, public hideLoading: boolean) {}
  }

  export class Authenticate {

    static readonly type = '[UserAction] Authenticate';
    constructor(public email: string, public password: string, public hideLoading: boolean) {}
  }

  export class RefreshToken {

    static readonly type = '[UserAction] RefreshToken';
    constructor() {}
  }

  export class ChangeDarkMode {

    static readonly type = '[UserAction] ChangeDarkMode';
    constructor(public mode: boolean) {}
  }

}
